import * as React from 'react'
import { SVGProps } from 'react'
const SvgInstagramColored = (props: SVGProps<SVGSVGElement>) => (
  <svg width={15} height={15} viewBox="0 0 15 15" fill="none" {...props}>
    <path
      d="M10.36.591H4.706A4.17 4.17 0 0 0 .542 4.757v5.651a4.17 4.17 0 0 0 4.165 4.166h5.652a4.17 4.17 0 0 0 4.166-4.166V4.757A4.17 4.17 0 0 0 10.359.59Zm2.758 9.817a2.759 2.759 0 0 1-2.759 2.759H4.707a2.759 2.759 0 0 1-2.758-2.759V4.757a2.759 2.759 0 0 1 2.758-2.76h5.652a2.759 2.759 0 0 1 2.759 2.76v5.651Z"
      fill="url(#a)"
    />
    <path
      d="M7.533 3.966a3.62 3.62 0 0 0-3.616 3.616A3.62 3.62 0 0 0 7.533 11.2a3.62 3.62 0 0 0 3.617-3.617 3.62 3.62 0 0 0-3.617-3.616Zm0 5.826a2.21 2.21 0 1 1 0-4.42 2.21 2.21 0 0 1 0 4.42Z"
      fill="url(#b)"
    />
    <path
      d="M11.157 4.86a.867.867 0 1 0 0-1.734.867.867 0 0 0 0 1.734Z"
      fill="url(#c)"
    />
    <defs>
      <linearGradient
        id="a"
        x1={7.533}
        y1={14.533}
        x2={7.533}
        y2={0.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E09B3D" />
        <stop offset={0.3} stopColor="#C74C4D" />
        <stop offset={0.6} stopColor="#C21975" />
        <stop offset={1} stopColor="#7024C4" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={7.533}
        y1={14.533}
        x2={7.533}
        y2={0.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E09B3D" />
        <stop offset={0.3} stopColor="#C74C4D" />
        <stop offset={0.6} stopColor="#C21975" />
        <stop offset={1} stopColor="#7024C4" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={11.157}
        y1={14.533}
        x2={11.157}
        y2={0.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E09B3D" />
        <stop offset={0.3} stopColor="#C74C4D" />
        <stop offset={0.6} stopColor="#C21975" />
        <stop offset={1} stopColor="#7024C4" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgInstagramColored
